import React, { useContext } from 'react'
import { Dimmer, Icon, Modal, Popup, Segment } from 'semantic-ui-react'
import { AppSettingsContext } from '../cnr/contexts/AppSettingsContext'
import { FrameworkContext } from '../cnr/contexts/FrameworkContent'
import { UiItemContext } from '../cnr/contexts/UiItemContext'
import { cnPlus, cn_s, cn_snp, cnnAdd } from '../common/cns'
import { uniqueKey } from '../common/keys'
import { DimmerWrap } from '../components/alerts/DimmerWrap'
import NotificationMessage from '../components/auth/signInComponents/NotificationMessage'
import { appIconTypes } from '../enums/appIconTypes'
import { gEnums } from '../enums/globalEnums'
import GenericIcon from '../genericControls/GenericIcon'
import MotionComponent from '../motions/MotionComponent'
import { H2Topper } from './TopperWrappers'
import TouchWrapper from './TouchWrapper'
import { _longPressDisplayTypes } from './LongPressWrapper'

export const wrapperTypes = {
  linking: 'linking',
  noContent: 'noContent',
  padded: 'padded',
  paddedContent: 'paddedContent',
  paddedFooter: 'paddedFooter',
  paddedHeader: 'paddedHeader',
  paddedHeaderAndFooter: 'paddedHeaderAndFooter',
  pending: 'pending',
  split: 'split',
  splitLR: 'splitLR',
  splitHorz: 'splitHorz',
  splitVert: 'splitVert',
  upload: 'upload',
}

const Wrapper = (props) => {

  const {
    asSegment,
    alphaMenu,
    bottom,
    cnAlt,
    confirmation,
    confirmationNoModal,
    containerRef,
    content,
    css,
    dt,
    footer,
    footer2,
    fullMode,
    fullWebPage,
    halfModal,
    handleBack,
    handleBackCaption,
    handleSwipedRight,
    header,
    help,
    inverted,
    longPressDisplayType,
    applyLongPress,
    manifest,
    modal,
    navigation,
    noMid,
    notFull,
    notification,
    other,
    path,
    popup,
    progress,
    search,
    style,
    top,
    topper,
    transition_fpw,
    updating,
    updatingCaption,
    uploader,
    usePlaceholder,
    wrapper,
    wrapperCss,
    wrapperType,
  } = props

  const _css = wrapperCss ? wrapperCss : css

  let {
    topper: css_topper,
    container: css_container,
    header: css_header,
    navigation: css_navigation,
    notification: css_notification,
    content: css_content,
    search: css_search,
    footer: css_footer,
    footer2: css_footer2
  } = _css ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { appDimensions, isMobileDevice, mediaDeviceType, frameworkLeftType, frameworkRightType } = framework_state ?? {}
  let { width, height } = appDimensions ?? {}

  // frameworkContext
  const uiItemContext = useContext(UiItemContext);
  const { item_state } = uiItemContext ?? {}

  if ((frameworkLeftType || frameworkRightType) && !item_state) {
    css_container += ' app-dark-mode'
  }

  const appSettingsContext = useContext(AppSettingsContext)
  const { appSettings_state } = appSettingsContext ?? {}
  const { currentAppDevice } = appSettings_state ?? {}
  const { msettings } = currentAppDevice ?? {}

  const buttonProps_cancel = { color: 'black', inverted: true }

  const gi = (key, iconName, onClick, clickOptions, opts, corner) => <GenericIcon giProps={{ key, iconName, onClick, clickOptions, opts, corner }} />
  const cancelButton = () => gi('btn-cancel', appIconTypes.delete, handleBack, null, { ...buttonProps_cancel, nb: false, nf: true })

  const getHeader = () => {
    if (header) {
      return header
    } else if (handleBack) {
      return <H2Topper
        leftContent={cancelButton()}
        rightContent={handleBackCaption ? handleBackCaption : 'Edit'}
      ></H2Topper>
    } else {
      return null
    }
  }

  if (msettings && msettings.w) { width = msettings.w }
  if (msettings && msettings.h) { height = msettings.h }

  if (halfModal && height) { height = height / 2 }

  const modalStyle = isMobileDevice ? { height: ' 100%', width: ' 100%' } : { height, width }

  let cssTop = cnPlus(css_topper)
  let cssT = cnPlus(css_container)
  let cssH = cnPlus(css_header)
  let cssO = cnPlus(css_notification)
  let cssN = cnPlus(css_navigation)
  let cssC = cnPlus(css_content)
  let cssF = cnPlus(css_footer)
  let cssF2 = cnPlus(css_footer2)
  let cssS = cnPlus(css_search)

  cssT = cnnAdd(cssT, wrapperType)

  let prefix = ' ';

  const _header = getHeader()

  if (topper) { prefix += 't' }
  if (_header) { prefix += 'h' }
  if (search) { prefix += 's' }
  if (navigation) { prefix += 'n' }
  if (notification) { prefix += 'o' }
  if (path) { prefix += 'p' }
  if (uploader) { prefix += 'u' }
  if (progress) { prefix += 'r' }
  if (top) { prefix += 't' }
  if (content) { prefix += 'c' }
  if (manifest) { prefix += 'm' }
  if (bottom) { prefix += 'b' }
  if (footer) { prefix += 'f' }
  if (footer2) { prefix += 'f' }


  let cn = dt ? 'dt-container' : 'vert-container'
  if (notFull) { cn += ' nf' }

  if (asSegment) {
    cssT += ' ui segments'
    cssTop += cn_s(inverted)
    cssH += cn_s(inverted)
    cssN += cn_s(inverted)
    cssO += cn_s(inverted)
    cssC += cn_snp(inverted)
    cssF += cn_s(inverted)
    cssF2 += cn_s(inverted)
  }

  const help_popup = () => <Popup
    header={help.title}
    content={help.content}
    on='click'
    position='top right'
    size='tiny'
    trigger={<Icon className={'hlp-icn'} circular size='large' inverted color='grey' name='info' />}
  />

  const notificationDiv = (n) => <NotificationMessage notification={notification} />

  const cn_content = noMid || longPressDisplayType === _longPressDisplayTypes.partial ? 'content' : 'content mid'

  const main = <React.Fragment>
    {topper && <div key={uniqueKey('wr', 't')} className={'topper' + cssH}>{topper}</div>}
    {_header && <div key={uniqueKey('wr', 'h')} className={'header' + cssH}>{_header}</div>}
    {search && <div key={uniqueKey('wr', 's')} className={'search' + cssS} >{search}</div>}
    {help && help_popup()}
    {notification && <div key={uniqueKey('wr', 'o')} className={'notification' + cssO}>{notificationDiv(notification)}</div>}
    {navigation && <div key={uniqueKey('wr', 'n')} className={'navigation' + cssN}>{navigation}</div>}
    {path && <div key={uniqueKey('wr', 'p')} className={'path' + cssN}>{path}</div>}
    {uploader && <div key={uniqueKey('wr', 'u')} className={'uploader' + cssN}>{uploader}</div>}
    {progress && <div key={uniqueKey('wr', 'r')} className={'progress' + cssN}>{progress}</div>}
    {top && <div key={uniqueKey('wr', 'o')} className={'top' + cssC}>{top}</div>}
    {content && <div key={uniqueKey('wr', 'c')} className={cn_content + cssC}>{content} </div>}
    {bottom && <div key={uniqueKey('wr', 'bt')} className={'bottom' + cssC}>{bottom}</div>}
    {footer && <div key={uniqueKey('wr', 'f')} className={'footer' + cssF}>{footer}</div>}
    {footer2 && <div key={uniqueKey('wr', 'ff')} className={'footer2' + cssF2}>{footer2}</div>}
    {alphaMenu && alphaMenu}
  </React.Fragment>

  let sty = style ?? {}
  let cn_modal = fullMode ? 'modal-full cntr' : 'cntr'

  switch (mediaDeviceType) {
    case gEnums.mediaDeviceTypes.desktop:
      if (fullMode) { cn_modal += ' modal-wide ' }
      break;
    default:
    // nothing
  }

  if (fullWebPage) { cn_modal += ' full-web-page' }

  if (cnAlt) { cn += ' ' + cnAlt }

  let _updating = updating

  if (confirmation) {
    console.log('_updating', _updating)
    console.log('confirmation', confirmation)
  }


  const dimmerWrap = () => <DimmerWrap
    confirmation={confirmation}
    confirmationNoModal={confirmationNoModal}
    caption={updatingCaption}
  />

  const modalModal = () => <Modal
    style={modalStyle}
    open={true}
    className={cn_modal}
  >
    {transition_fpw?.showTransition ?
      <MotionComponent transition={transition_fpw}>
        {_updating && dimmerWrap()}
        {main}
        {popup && popup}
      </MotionComponent>
      :
      <div className={cn + prefix + cssT} style={sty}>
        {_updating && dimmerWrap()}
        {main}
        {popup && popup}
      </div>
    }
  </Modal>

  // THIS IS NOT Full
  const overlayModal = () => {
    return (
      <div className="overlay-page app-dark-mode">
        <div className="overlay-content">
          {main}
        </div>
      </div>
    );
  }

  const wrapperWrapper = () => <div className={cn + prefix + cssT} style={sty}>
    <div className={wrapper} ref={containerRef}>
      {_updating && dimmerWrap()}
      {main}
      {popup && popup}
    </div>
  </div>

  const noWrapper = () => <Dimmer.Dimmable className={cn + prefix + cssT} style={sty}>
    {_updating && dimmerWrap()}
    {main}
    {popup && popup}
  </Dimmer.Dimmable>

  const wrapperPlaceholder = (content) => <Segment placeholder basic>
    {content}
  </Segment>

  const _isOverlay = false

  const wrapperContent = () => {
    if (_isOverlay) {
      return overlayModal()
    } else if (modal) {
      if (handleSwipedRight) {
        return <TouchWrapper handleSwipedRight={handleSwipedRight}>
          {modalModal()}
        </TouchWrapper>
      } else {
        return modalModal()
      }
    } else {
      if (wrapper) {
        return wrapperWrapper()
      } else {
        if (usePlaceholder) {
          return wrapperPlaceholder(noWrapper())
        } else {
          return noWrapper()
        }
      }
    }
  }

  return wrapperContent()

}

export default Wrapper